export default __webpack_public_path__ + "static/media/boost-b.b00a7506.svg";